import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import TicketOptions from "./TicketOptions";
import { useNavigate } from "react-router-dom";

export default function BookingFormPage() {
  const [startDate, setStartDate] = useState(new Date());
  const [subtotal, setSubtotal] = useState(0);
  const [selectedTicketsArray, setSelectedTicketsArray] = useState([]);

  const [nameValue, setNameValue] = useState("");
  const [emailValue, setEmailValue] = useState("");
  const [phoneValue, setPhoneValue] = useState("");

  const navigate = useNavigate();

  // ✅ Точное форматирование через RegExp (всегда точки)
  const formatIDR = (amount) =>
    amount?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

  const handlePayment = () => {
    const bookingSummary = {
      name: nameValue,
      email: emailValue,
      phone: phoneValue,
      visitDate: startDate.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      }),
      tickets: selectedTicketsArray,
      total: subtotal,
    };

    localStorage.setItem("bookingDetails", JSON.stringify(bookingSummary));
    navigate("/payment");
  };

  return (
    <div className="bg-cover bg-center py-10 px-4 sm:px-6">
      <div className="max-w-4xl mx-auto bg-white/70 backdrop-blur-sm rounded-2xl p-6 md:p-10 shadow-md text-gray-800">
        <h2 className="text-2xl font-bold mb-6 text-center md:text-left">Personal Information</h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          <div>
            <label className="block font-medium mb-1">Full Name</label>
            <input
              type="text"
              value={nameValue}
              onChange={(e) => setNameValue(e.target.value)}
              className="w-full rounded-md border border-gray-300 px-4 py-2 bg-white/60 focus:outline-none focus:ring focus:ring-blue-300"
            />
          </div>
          <div>
            <label className="block font-medium mb-1">Phone Number</label>
            <input
              type="text"
              value={phoneValue}
              onChange={(e) => setPhoneValue(e.target.value)}
              className="w-full rounded-md border border-gray-300 px-4 py-2 bg-white/60 focus:outline-none focus:ring focus:ring-blue-300"
            />
          </div>
          <div className="md:col-span-2">
            <label className="block font-medium mb-1">Email</label>
            <input
              type="email"
              value={emailValue}
              onChange={(e) => setEmailValue(e.target.value)}
              className="w-full rounded-md border border-gray-300 px-4 py-2 bg-white/60 focus:outline-none focus:ring focus:ring-blue-300"
            />
          </div>
        </div>

        <h2 className="text-2xl font-bold mt-10 mb-4 text-center md:text-left">Ticket</h2>

        <div className="mb-6">
          <label className="block font-medium mb-1">Visit Date</label>
          <DatePicker
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            className="w-full rounded-md border border-gray-300 px-4 py-2 bg-white/60 focus:outline-none focus:ring focus:ring-blue-300"
            dateFormat="dd MMM yyyy"
            minDate={new Date()}
            showPopperArrow={false}
          />
        </div>

        <p className="text-sm text-gray-700 mb-2">
          Ticket available for selected date
        </p>

        <TicketOptions
          onSubtotalChange={setSubtotal}
          onTicketSelectionChange={setSelectedTicketsArray}
          formatPrice={formatIDR} // 👈 передаём функцию форматирования внутрь TicketOptions
        />

        <div className="mt-10 border-t pt-6">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4 gap-2">
            <span className="font-semibold text-gray-800">Subtotal</span>
            <span className="font-semibold">IDR {formatIDR(subtotal)}</span>
          </div>

          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mt-6">
            <span className="text-xl font-semibold text-gray-800">Total</span>
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 sm:gap-4 w-full sm:w-auto">
              <span className="text-xl font-semibold">
                IDR {formatIDR(subtotal)}
              </span>
              <button
                onClick={handlePayment}
                className="w-full sm:w-auto bg-orange-500 text-white font-semibold px-6 py-2 rounded-full hover:bg-orange-600 transition text-center"
              >
                CONTINUE PAYMENT
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
